import React, { useContext } from "react";
import moment from "moment";
import { formatPrice, getSystemSettings } from "../../../../functions/Functions";
import { SettingsContext } from "../../../../contexts/Settings";

const PosSessionActivityReport = (props) => {
  const { reportData, componentRefPosSession } = props;
  const { generalSettings } = useContext(SettingsContext);
  console.log("PosSessionActivityReport", reportData);

  if (!reportData) return null;
  let denominationTotal = 0;
  let saleSummary = {
    no_of_doc: 0,
    amount: 0,
    discount: 0,
    net: 0,
  }

  let totalCashPaidDocs = 0;
  let totalCashPaidAmount = 0;
  
  let totalSalesActivityAmount = 0;

  return (
    <div className="d-none">
      <div ref={componentRefPosSession} className="fk-print-text_pos w-100">
        {/* Header section */}
        <div className="text-center mb-3">
          <h4 className="font-weight-bold border-bottom border-top border-dark py-1 m-0">
            {reportData.header?.report_name || 'POS Session Activity Report'}
          </h4>
        </div>

        {/* Info Table */}
        <table className="table table-sm table-bordered border-dark border-dark">
          <tbody>
            <tr>
              <th colSpan="2" className="text-center border-1 border border-dark">
                {getSystemSettings(generalSettings, "siteName")}
              </th>
            </tr>
            <tr>
              <th colSpan="2" className="text-center border-1 border border-dark">
                Counter : {reportData.header?.branch_name || "Branch Name"}
              </th>
            </tr>
            <tr>
              <th colSpan="2" className="text-center border-1 border border-dark">
                Shift : Mid Day/ Final Closing
              </th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "45%" }}>Opening Date</th>
              <td className="border-1 border border-dark text-right">{reportData.header?.opening_date ? moment(reportData.header?.opening_date).format("DD-MM-YYYY, dddd, h:mm a") : "-"}</td>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Closing Date</th>
              <td className="border-1 border border-dark text-right">{reportData.header?.closing_date ? moment(reportData.header?.closing_date).format("DD-MM-YYYY, dddd, h:mm a") : "-"}</td>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Printed Date</th>
              <td className="border-1 border border-dark text-right">{moment().format("DD-MM-YYYY, dddd, h:mm a")}</td>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Session Open Operator</th>
              <td className="border-1 border border-dark text-right">{reportData.header?.session_open_operator || "-"}</td>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Session Closing Operator</th>
              <td className="border-1 border border-dark text-right">{reportData.header?.session_closing_operator || "-"}</td>
            </tr>
          </tbody>
        </table>

        {/* Sale Summary */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="4" className="text-center border-1 border border-dark">Sale Summary</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "27%" }}>Document Type</th>
              <th className="border-1 border border-dark">No Of Documents</th>
              <th className="border-1 border border-dark">Amount</th>
              <th className="border-1 border border-dark">Discount</th>
              <th className="border-1 border border-dark text-right">Net</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colSpan="5" className="border-1 border border-dark">Sale Invoice</th>
            </tr>
            {Array.isArray(reportData?.sale_summary) && reportData.sale_summary.map((item, index) => {
              saleSummary.no_of_doc += parseFloat(item.no_of_docs) || 0;
              saleSummary.amount += parseFloat(item.amount) || 0;
              saleSummary.discount += parseFloat(item.discount) || 0;
              saleSummary.net += parseFloat(item.net) || 0;
              return (
              <tr key={index}>
                <td className="border-1 border border-dark">{item.doc_type}</td>
                <td className="border-1 border border-dark">{item.no_of_docs}</td>
                <td className="border-1 border border-dark">{item.amount}</td>
                <td className="border-1 border border-dark">{item.discount}</td>
                <td className="border-1 border border-dark text-right">{item.net}</td>
              </tr>
            )})}
            <tr>
              <th colSpan="5" className="border-1 border border-dark">Sale Return</th>
            </tr>
            {reportData?.sale_return_summary ? (() => {
              saleSummary.no_of_doc += parseFloat(reportData.sale_return_summary.no_of_docs) || 0;
              saleSummary.amount -= parseFloat(reportData.sale_return_summary.amount) || 0;
              saleSummary.discount -= parseFloat(reportData.sale_return_summary.discount) || 0;
              saleSummary.net -= parseFloat(reportData.sale_return_summary.net) || 0;
              return (
                <tr>
                  <td className="border-1 border border-dark">{reportData.sale_return_summary.doc_type || 'Sale Return'}</td>
                  <td className="border-1 border border-dark">{reportData.sale_return_summary.no_of_docs || 0}</td>
                  <td className="border-1 border border-dark">{reportData.sale_return_summary.amount || 0}</td>
                  <td className="border-1 border border-dark">{reportData.sale_return_summary.discount || 0}</td>
                  <td className="border-1 border border-dark text-right">{reportData.sale_return_summary.net || 0}</td>
                </tr>
              );
            })() : (
              <tr>
                <td colSpan="5" className="text-center border-1 border border-dark">-</td>
              </tr>
            )}
           
            <tr>
              <th className="border-1 border border-dark">Net Amount</th>
              <th className="border-1 border border-dark">{saleSummary.no_of_doc || 0}</th>
              <th className="border-1 border border-dark">{formatPrice(saleSummary.amount || 0)}</th>
              <th className="border-1 border border-dark">{formatPrice(saleSummary.discount || 0)}</th>
              <th className="border-1 border border-dark text-right">{formatPrice(saleSummary.net || 0)}</th>
            </tr>
          </tbody>
        </table>

        {/* Cash Received Summary */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="2" className="text-center border-1 border border-dark">Cash Received Summary</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-1 border border-dark" style={{ width: "60%" }}>Opening Amount</td>
              <td className="border-1 border border-dark text-right">{reportData?.cash_received_summary?.opening_amount ?? "-"}</td>
            </tr>
            <tr>
              <td className="border-1 border border-dark">Cash Sales</td>
              <td className="border-1 border border-dark text-right">{reportData?.cash_received_summary?.collected_amount ?? "-"}</td>
            </tr>
            <tr>
              <td className="border-1 border border-dark">Expenses</td>
              <td className="border-1 border border-dark text-right">{reportData?.cash_received_summary?.expenses ?? "-"}</td>
            </tr>
            <tr>
              <td className="border-1 border border-dark">Total Amount</td>
              <td className="border-1 border border-dark text-right">{reportData?.cash_received_summary?.total_payable_amount ?? "-"}</td>
            </tr>
          </tbody>
        </table>

        {/* Cash Paid Summary */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="3" className="text-center border-1 border border-dark">Cash Paid Summary</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "45%" }}>Details</th>
              <th className="border-1 border border-dark">No Of Docs</th>
              <th className="border-1 border border-dark text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {reportData?.cash_paid_summary?.map((item, index) => {
              totalCashPaidDocs += (parseInt(item.no_of_docs) || 0);
              totalCashPaidAmount += (parseFloat(item.amount) || 0);
              return (
                <tr key={`paid-${index}`}>
                  <td className="border-1 border border-dark">{item.details}</td>
                  <td className="border-1 border border-dark">{item.no_of_docs}</td>
                  <td className="border-1 border border-dark text-right">{item.amount}</td>
                </tr>
              );
            })}
            {(!reportData?.cash_paid_summary || reportData.cash_paid_summary.length === 0) && (
              <>
                <tr>
                  <td className="border-1 border border-dark">Sales Return</td>
                  <td className="border-1 border border-dark">-</td>
                  <td className="border-1 border border-dark text-right">-</td>
                </tr>
              </>
            )}
            <tr>
              <th className="border-1 border border-dark">Total Amount</th>
              <th className="border-1 border border-dark">{totalCashPaidDocs}</th>
              <th className="border-1 border border-dark text-right">{totalCashPaidAmount}</th>
            </tr>
            <tr>
              <th colSpan="2" className="border-1 border border-dark">Net Cash</th>
              <th className="border-1 border border-dark text-right">{totalCashPaidAmount}</th>
            </tr>
          </tbody>
        </table>

        {/* Tax & Charges Summary */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="2" className="text-center border-1 border border-dark">Tax & Charges Summary</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "60%" }}>Description</th>
              <th className="border-1 border border-dark text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="border-1 border border-dark">GST</td>
              <td className="border-1 border border-dark text-right">{reportData?.tax_and_charges_summary?.gst || 0}</td>
            </tr>
            <tr>
              <td className="border-1 border border-dark">Delivery Charges</td>
              <td className="border-1 border border-dark text-right">{reportData?.tax_and_charges_summary?.delivery_charges || 0}</td>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Total</th>
              <th className="border-1 border border-dark text-right">
                {((parseFloat(reportData?.tax_and_charges_summary?.gst || 0) + parseFloat(reportData?.tax_and_charges_summary?.delivery_charges || 0)) || 0)}
              </th>
            </tr>
            {reportData?.tax_and_charges_summary?.tax_by_payment_type?.length > 0 ? (
              reportData.tax_and_charges_summary.tax_by_payment_type.map((item, index) => (
                <tr key={`tax-payment-${index}`}>
                  <td className="border-1 border border-dark">Sales Tax- {item.payment_type}</td>
                  <td className="border-1 border border-dark text-right">{item.gst || 0}</td>
                </tr>
              ))
            ) : (
              <>
                <tr>
                  <td className="border-1 border border-dark">Sales Tax- Cash</td>
                  <td className="border-1 border border-dark">0</td>
                </tr>
                <tr>
                  <td className="border-1 border border-dark">Sales Tax- Card</td>
                  <td className="border-1 border border-dark">0</td>
                </tr>
              </>
            )}
          </tbody>
        </table>

        {/* Currency Denominations */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="3" className="text-center border-1 border border-dark">Currency Denominations</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "40%" }}>Name</th>
              <th className="border-1 border border-dark text-center">Quantity</th>
              <th className="border-1 border border-dark text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {reportData?.currency_denominations && Array.isArray(reportData.currency_denominations) && reportData.currency_denominations.length > 0 ? (
              <>
                {reportData.currency_denominations.map((item, index) => {
                  denominationTotal += parseFloat(item.amount);
                  return (
                    <tr key={index}>
                      <td className="border-1 border border-dark">{item.name}</td>
                      <td className="border-1 border border-dark text-center">{item.quantity}</td>
                      <td className="border-1 border border-dark text-right">{item.amount}</td>
                    </tr>
                  )
                })}
                <tr>
                  <th colSpan="2" className="border-1 border border-dark">Total</th>
                  <th className="border-1 border border-dark text-right">
                    {formatPrice(denominationTotal)}
                  </th>
                </tr>
              </>
            ) : (
              <tr>
                <td colSpan="3" className="text-center border-1 border border-dark">No data</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Difference Summary */}
        {/* <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="5" className="text-center border-1 border border-dark">Difference Summary</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark">Mode of Payment</th>
              <th className="border-1 border border-dark">Expected</th>
              <th className="border-1 border border-dark">Closing</th>
              <th className="border-1 border border-dark">Diff</th>
              <th className="border-1 border border-dark">Status</th>
            </tr>
          </thead>
          <tbody>
            {['Cash at Branch', 'Jazz Cash', 'BAF', 'ABL', 'EASY PAISA', 'ONLINE', 'FOOD PANDA'].map((mode, idx) => (
              <tr key={idx}>
                <td className="border-1 border border-dark">{mode}</td>
                <td className="border-1 border border-dark"></td>
                <td className="border-1 border border-dark"></td>
                <td className="border-1 border border-dark"></td>
                <td className="border-1 border border-dark"></td>
              </tr>
            ))}
            <tr>
              <th className="border-1 border border-dark">TOTAL</th>
              <th className="border-1 border border-dark"></th>
              <th className="border-1 border border-dark"></th>
              <th className="border-1 border border-dark"></th>
              <th className="border-1 border border-dark"></th>
            </tr>
          </tbody>
        </table> */}

        {/* Merchant Summary */}
        <table className="table table-sm table-bordered border-dark mt-3 border-dark">
          <thead>
            <tr>
              <th colSpan="3" className="text-center border-1 border border-dark">Merchant Summary</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "45%" }}>Merchant Name</th>
              <th className="border-1 border border-dark">No Of Doc</th>
              <th className="border-1 border border-dark text-right">Amount</th>
            </tr>
          </thead>
          <tbody>
            {reportData?.merchant_summary?.map((item, index) => (
              <tr key={`merchant-${index}`}>
                <td className="border-1 border border-dark">{item.merchant_name}</td>
                <td className="border-1 border border-dark">{item.no_of_doc}</td>
                <td className="border-1 border border-dark text-right">{item.amount}</td>
              </tr>
            ))}
            {(!reportData?.merchant_summary || reportData.merchant_summary.length === 0) && (
              <tr>
                <td colSpan="3" className="text-center border-1 border border-dark">No data</td>
              </tr>
            )}
          </tbody>
        </table>

        {/* POS ACTIVITY DETAILS */}
        <table className="table table-sm table-bordered border-dark mt-3 mb-5 border-dark">
          <thead>
            <tr>
              <th colSpan="3" className="text-center border-1 border border-dark">POS ACTIVITY DETAILS</th>
            </tr>
            <tr>
              <th className="border-1 border border-dark" style={{ width: "45%" }}>Closing Cash Deposit Details</th>
              <th className="border-1 border border-dark">Amount</th>
              <th className="border-1 border border-dark">Voucher Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th colSpan="3" className="border-1 border border-dark">Payment Voucher Expenses Details</th>
            </tr>
            {reportData?.sales_activity?.length > 0 ? (
              reportData.sales_activity.map((item, index) => {
                totalSalesActivityAmount += (parseFloat(item.amount) || 0);
                return (
                  <tr key={`sales-activity-${index}`}>
                    <td className="border-1 border border-dark">{item.details || item.deposit_details || "-"}</td>
                    <td className="border-1 border border-dark">{item.amount || "-"}</td>
                    <td className="border-1 border border-dark">{item.voucher_date || item.date || "-"}</td>
                  </tr>
                )
              })
            ) : (
              <tr>
                <td className="border-1 border border-dark">-</td>
                <td className="border-1 border border-dark">-</td>
                <td className="border-1 border border-dark">-</td>
              </tr>
            )}
            <tr>
              <th className="border-1 border border-dark">Grand Total</th>
              <th className="border-1 border border-dark">{totalSalesActivityAmount}</th>
              <th className="border-1 border border-dark">-</th>
            </tr>
            <tr>
              <td colSpan="3" className="border-0">
                <br/>
              </td>
            </tr>
            <tr>
              <th colSpan="2" className="border-1 border border-dark">Details</th>
              <th className="border-1 border border-dark text-right">Amount</th>
            </tr>
            <tr>
              <td colSpan="2" className="border-1 border border-dark">Take Away</td>
              <td className="border-1 border border-dark text-right">0</td>
            </tr>
            <tr>
              <td colSpan="2" className="border-1 border border-dark">Dine-In</td>
              <td className="border-1 border border-dark text-right">0</td>
            </tr>
            <tr>
              <td colSpan="2" className="border-1 border border-dark">Delivery</td>
              <td className="border-1 border border-dark text-right">0</td>
            </tr>
            <tr>
              <th colSpan="2" className="border-1 border border-dark">Total Amount</th>
              <th className="border-1 border border-dark text-right">0</th>
            </tr>
            <tr>
              <td colSpan="2" className="border-1 border border-dark">Total Sale</td>
              <td className="border-1 border border-dark text-right">0</td>
            </tr>
            <tr>
              <td colSpan="2" className="border-1 border border-dark">Total Return</td>
              <td className="border-1 border border-dark text-right">0</td>
            </tr>
            <tr>
              <th colSpan="2" className="border-1 border border-dark">Total Amount</th>
              <th className="border-1 border border-dark text-right">0</th>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PosSessionActivityReport;
